module.exports = __webpack_public_path__ + "static/media/diretora-juridica.51ba16c1.png";